import { useGet, useQueryWithErrorHandling } from '@app/sdk';

export function useRegularPayments({ accountId }: { accountId: string }) {
  const get = useGet(true, "rp");

  function getRegularPayments() {
    return get<any>(`/api/proxy/rp/regular-payments-service/accounts/${accountId}`);
  }

  return useQueryWithErrorHandling({
    queryKey: ['getRegularPayments', accountId],
    queryFn: getRegularPayments,
    enabled: !!accountId,
  });
}
